import React from "react";

const TableInput = React.forwardRef(({
  type = "text",
  value,
  onChange,
  disabled = false,
  min,
  max,
  placeholder = "",
  style = {},
  ...props
}, ref) => {
  return (
    <input
      ref={ref}
      type={type}
      value={value}
      onChange={onChange}
      disabled={disabled}
      min={min}
      max={max}
      placeholder={placeholder}
      style={style}
      {...props}
    />
  );
});

export default TableInput;

